"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
  stroke: "currentColor",
  strokeWidth: "2",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    id: "bell",
    transform: "translate(2.000000, 2.000000)",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M20,15 L0,15 C1.65685425,15 3,13.6568542 3,12 L3,7 C3.00000006,3.13400679 6.13400679,1.04308127e-07 10,1.04308127e-07 C13.8659932,1.04308128e-07 16.9999999,3.13400679 17,7 L17,12 C17,13.6568542 18.3431458,15 20,15 Z M11.73,19 C11.3722022,19.6168043 10.7130686,19.9964563 10,19.9964563 C9.28693139,19.9964563 8.62779776,19.6168043 8.27,19 L11.73,19 Z",
      id: "Shape"
    })
  })
}));